export const locale = {
	lang: 'fr_FR',
	data: {
		en_EN: 'EN',
		fr_FR: 'FR',
		es_ES: 'ES',
		pt_PT: 'PT',
		
		welcome: 'Bienvenue',
		hello: 'Bonjour',
		insert_email_login: 'Entrez votre e-mail pour vous connecter',
		insert_phone_login: 'Entrez le numéro de téléphone pour vous connecter',
		next: 'Suivant',
		auth_phone: 'Ou authentifiez-vous par téléphone',
		auth_email: "Ou authentifiez-vous par e-mail",
		no_account_login: "Vous n'avez pas de compte?",
		register: "S'inscrire",
		entry_catchphrase: "Vous n'avez pas de monnaie ? Laissez-nous faire",
		sign_in: "Se connecter",
		full_name: "Nom complet",
		email: "E-mail",
		phone_number: "Numéro de téléphone",
		already_have_account: "Vous avez déjà un compte ?",
		confirmation_code_title: 'Code de confirmation',
		confirmation_code_instruction_email: 'Entrez le code de confirmation reçu dans votre e-mail pour vous connecter',
		confirmation_code_instruction_phone: 'Entrez le code de confirmation reçu par SMS sur votre téléphone pour vous connecter',
		code_did_not_recieve: 'Vous n\'avez pas reçu le code ?',
		code_resend: 'Renvoyer le code',

		code_sent_success_email: 'Code de confirmation envoyé à votre e-mail.',
		code_sent_success_sms: 'Code de confirmation envoyé à votre téléphone.',
		code_resend_info: 'Code de confirmation renvoyé.',
		code_resend_error: 'Une erreur s\'est produite lors du renvoi du code de confirmation. Veuillez réessayer.',
		code_confirm_no_cred: 'Aucune information d\'identification fournie pour la confirmation.',
		code_confirm_error: 'Une erreur s\'est produite lors de la confirmation du code. Veuillez réessayer.',
		code_confirm_invalid_error: 'Le code saisi est incorrect.',

		login: 'Connexion',
		not_received_code: "Vous n'avez pas reçu le code ?",
		resend_code: 'Renvoyer',
		or_authenticate: 'Ou authentifiez-vous',
		via_phone: 'par téléphone',
		via_email: "par e-mail",
		confirm: "Confirmer",
		invalid_field: "Champ invalide",
		field_required: "Ce champ est requis",
		field_too_short: "Champ trop court",
		field_too_long: "Champ trop long",
		field_invalid_email: "Format d'e-mail invalide",
		field_invalid_phone: "Format de numéro de téléphone invalide",
		with_another_method: "avec une autre méthode",
		wrong_code: "Le code que vous avez saisi est incorrect",
		remaining_attempt: "Tentatives restantes : ",

		movements: 'Mouvements',
		use_balance: 'Utiliser',
		back_to_top: 'Retour en haut',

		login_error: 'Échec de la connexion. Veuillez réessayer.',
		login_invalid_error: 'Identifiants de connexion invalides. Veuillez vérifier vos informations.',
		login_user_not_found_error: 'Utilisateur non trouvé. Veuillez vérifier vos informations.',
		signup_error: 'Échec de l\'inscription. Veuillez réessayer.',
		signup_user_already_exists_error: 'Le numéro de téléphone existe déjà. Veuillez utiliser un numéro différent ou vous connecter.',
		signup_invalid_error: 'Données d\'inscription invalides. Veuillez vérifier vos informations.',

		location_not_authorized_warning: 'Accès à la localisation non autorisé. Veuillez activer les permissions de localisation pour trouver les points de vente à proximité.',

		points_of_sale_error: 'Échec du chargement des points de vente à proximité. Veuillez réessayer.',

		session_expired_error: 'Session expirée. Veuillez vous reconnecter.',

		no_options_select: 'Aucune option disponible',
		select_country: 'Sélectionner le pays',

		page_not_found: 'Page introuvable',
		page_not_found_description: 'La page que vous recherchez n\'existe pas ou une autre erreur s\'est produite. Revenez en arrière ou retournez à la page d\'accueil en cliquant sur le bouton ci-dessous.',
		return: 'Retour',

		balance: 'Solde',
		add_balance: 'Ajouter du solde',
		add_card: 'Ajouter une carte',

		read_qr_code: 'Lire le code QR',
		read_qr_code_instructions: 'Approchez votre smartphone de la machine pour lire le code QR.',
		add_physical_card: 'Carte physique',
		pass_card: 'Passer la carte',
		pass_card_instructions: 'Passez votre carte physique sur le lecteur de la machine pour continuer.',
		confirm_card: 'Confirmer la carte',
		confirm_card_instructions: 'Passez à nouveau la carte sur le lecteur de la machine pour confirmer vos données.',
		finish_card: 'Carte ajoutée',
		add_another_card: 'Ajouter une autre carte',
		finish: 'Terminé',
		finish_card_instructions: 'Votre carte a été ajoutée avec succès à votre portefeuille numérique.',
		cancel: 'Annuler',

		subdomain_not_found: 'Aucun sous-domaine trouvé ou sous-domaine invalide',
		subdomain_not_found_description: 'Un sous-domaine valide n\'a pas pu être trouvé, l\'URL insérée doit contenir un sous-domaine valide.',
		balance_use: 'Utiliser le solde',
		balance_use_page_title: 'Définissez le montant à utiliser',
		available_balance: 'Solde disponible',
		approve_use: 'Approuvez pour poursuivre l\'opération',
		add_to_machine: 'Ajouter du crédit',

		amount_too_low: 'El importe introducido es demasiado bajo',
		amount_too_high: 'El importe introducido es demasiado alto',

		identify_machine: 'Identifier la machine',
		scan_qr_code: 'Scanner le code QR',
		machine_code: 'Code de la machine',
		insert_code: 'Insérer le code',
		
		toast_error_invalid_machine: 'Le code de la machine est invalide ou la carte sélectionnée ne peut pas être utilisée sur la machine.',

		credit_sent: 'Crédit envoyé',
		transaction_approved: 'Transaction approuvée',
		go_to_home: 'Page d\'accueil',

		toast_error_transaction_get_error: 'Une erreur s\'est produite lors de la récupération des transactions.',

		
		add_card_description: 'Quel type de carte souhaitez-vous ajouter ?',
		add_virtual_card: 'Carte virtuelle',
		
		scan_qrcode: 'Scanner le code QR',
		error_no_camera_found: 'Aucune caméra trouvée. Veuillez vous assurer que votre appareil dispose d\'une caméra et que les autorisations nécessaires sont accordées.',
		toast_info_camera_permission_required: 'L\'autorisation de la caméra est requise pour scanner des codes QR. Veuillez activer l\'accès à la caméra dans les paramètres de votre appareil.',
		toast_error_no_camera_found: 'Aucune caméra trouvée. Veuillez vous assurer que votre appareil dispose d\'une caméra et que les autorisations nécessaires sont accordées.',
		
		toast_error_verifying_card: 'Une erreur s\'est produite lors de la vérification de la carte.',
		toast_error_scanning_card: 'Une erreur s\'est produite lors de la numérisation de la carte. Veuillez réessayer.',

		go_to_cards: 'Aller à mes cartes',

		or_insert_code: 'ou insérer le code',

		promos: 'Règles',
		promo: 'Règle',

		toast_error_fetching_cards: 'Une erreur s\'est produite lors de la récupération de vos cartes.',
		
		sign_out: 'Se déconnecter',
		dialog_signout: 'Souhaitez-vous vous déconnecter de votre compte ?',
		
		toast_pwa_get_error: 'Une erreur s\'est produite lors de la récupération du portefeuille.',
		home_find_wallet: 'Trouvez votre portefeuille de fidélité',
		loyalty_wallet_recents: 'Portefeuilles de fidélité récents',
		home_insert_code: 'Insérer le code',
		or: 'ou',

		toast_error_getting_pwas: 'Une erreur s\'est produite lors de la récupération de vos portefeuilles les plus récents.',

		select_recent_machines: 'Sélectionnez des machines récentes',

		forgot_password: 'Mot de passe oublié ?',
		email_input: 'E-mail',
		password_input: 'Mot de passe',
		login_wallet: 'Se connecter',
		login_wallet_description: 'Entrez votre e-mail et votre mot de passe pour utiliser votre Wallet',
		login_button: 'Se connecter',
		login_no_account: 'Pas de compte ?',
		login_register: 'Créer un compte',
		confirm_password_input: 'Confirmer le mot de passe',
		signup_wallet_already_have_account: 'Vous avez déjà un compte ?',
		signup_login: 'Se connecter',
		signup_wallet: 'S’inscrire',
		signup_wallet_description: 'Créez votre compte.',
		signup_button: 'S’inscrire',
		reset_password: 'Réinitialiser le mot de passe',
		reset_password_description: 'Réinitialisez votre mot de passe en saisissant votre e-mail',
		reset_password_button: 'Réinitialiser',
		reset_login: 'Se connecter',
		reset_password_verified_email: 'Si votre e-mail est enregistré, vous recevrez un e-mail pour réinitialiser votre mot de passe.',

		toast_signup_email_sent: 'Un e-mail a été envoyé pour vérifier votre compte.',
		toast_success_reset_password: 'Si vous avez un compte, nous vous avons envoyé un e-mail avec des instructions supplémentaires.',

		error_email_invalid: 'L\'e-mail n\'est pas valide.',
		error_email_required: 'L\'e-mail est requis.',

		error_password_required: 'Le mot de passe est requis.',
		error_password_too_short: 'Le mot de passe est trop court.',
		error_password_mismatch: 'Les mots de passe doivent correspondre.',

		toast_error_login_invalid: 'E-mail ou mot de passe invalide.',

		server_unreachable: 'Impossible de contacter le serveur. Veuillez vérifier votre connexion et réessayer.',
	},
};